exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv.v-radio.theme--light > label[data-v-1bf3d8b2] {\n  font-size: 14px;\n}\n.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot[data-v-1bf3d8b2] {\n  margin-bottom: 0;\n}\ndiv.v-input__slot > label[data-v-1bf3d8b2] {\n  font-size: 14px;\n}\n.v-messages[data-v-1bf3d8b2] {\n  min-height: 0;\n  height: 0;\n}\n.v-input--selection-controls[data-v-1bf3d8b2] {\n  margin-top: 5px;\n}\n", ""]);

// exports
